module.exports = __webpack_public_path__ + "static/media/aarti.e6a7a6d0.svg";